<template>
  <v-card outlined class="mb-2">
    <v-card-title class="pa-4 subtitle-1">
      Application List
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon :color="pdf ? 'green' : 'grey'" v-on="on" @click="filter()">
            <v-icon>mdi-file-pdf</v-icon>
          </v-btn>
        </template>
        <span>Find applications without a PDF</span>
      </v-tooltip>
      <v-autocomplete
        item-text="name"
        item-value="name"
        v-model="property"
        class="filter-date ml-2"
        dense
        hide-details
        :items="propertys"
        clearable
        label="Property"
      />
      <DatePicker v-model="from" label="From Date" />
      <DatePicker v-model="to" label="To Date" />
      <v-btn @click="update" depressed class="primary ml-2" height="35">Apply</v-btn>
    </v-card-title>
  </v-card>
</template>

<script>
import DatePicker from "../components/Date";
import moment from "moment";
export default {
  name: "Submissions",
  props: ["value"],
  components: {
    DatePicker
  },
  data() {
    return {
      pdf: false,
      property: "",
      from: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD")
    };
  },
  computed: {
    propertys() {
      return this.$store.getters.table;
    }
  },
  methods: {
    filter() {
      const vm = this;
      vm.pdf = !vm.pdf;
      vm.update();
    },
    update() {
      const vm = this;
      vm.$emit("input", {
        pdf: vm.pdf,
        from: vm.from,
        property: vm.property,
        to: vm.to
      });
    }
  }
};
</script>

<style></style>
